<template>
  <div class="overlay">
    <div class="line-section" :style="getLineStyle(1)"></div>
    <div class="line-section" :style="getLineStyle(2)"></div>
  </div>
</template>

<script>
import {
  FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA,
  FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA_OPAQUE,
} from '@/constants/colors';

export default {
  props: {
    boundingBox: {
      type: Object,
      required: true,
    },
    boundingBoxes: {
      type: Array,
      required: true,
    },
    color: {
      type: [Array, String],
      required: true,
    },
    zoomFactor: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getLineStyle(part) {
      const color_1 = FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA;
      const color_2 = FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA_OPAQUE;
      return {
        marginTop: `${this.boundingBox.height}px`,
        position: `absolute`,
        width: `${this.boundingBox.width}px`,
        /* Height set to clip correctly basically background-size/2 */
        height: `${5 * this.zoomFactor}px`,
        background:
          part === 1
            ? `linear-gradient(45deg, ${color_1}, ${color_1} 45%, ${color_2} 45%, ${color_2} 55%, ${color_1} 55%)`
            : `linear-gradient(-45deg, ${color_1}, ${color_1} 45%,  ${color_2} 45%, ${color_2} 55%, ${color_1} 55%)`,
        backgroundSize: `${10 * this.zoomFactor}px ${10 * this.zoomFactor}px`,
      };
    },
  },
};
</script>
